export default __webpack_public_path__ + "static/media/nodeckFilter.ed7a0a72.svg";